import type { ClientDerivativeOptions } from '../calcClientDerivatives';

// Single resolution point for the claim-projection-engine gate. An explicit
// option wins (tests and preview/comparison flows force an engine without
// mutating the setting), then the persisted per-client calculation setting
// (set via a flag-gated UI toggle, stored in the DB, and loaded onto the
// client — it travels with the client data, so server and client agree
// without out-of-band flag plumbing).
//
// Used by BOTH the funding calc (which engine prices claims) and the Stage-1
// phase-cost calc (which cost model prices care), so one derivative pass can
// never straddle the two models.
export function resolveUseClaimProjectionEngine(
  client: Client,
  options: ClientDerivativeOptions = {},
): boolean {
  return (
    options.useClaimProjectionEngine ??
    client.clientCalculationSettings?.useClaimProjectionEngine ??
    false
  );
}
